export enum MessageEnum {
  AnnotationsCreate = 'annotations.create',
  AnnotationsDestroy = 'annotations.destroy',
  AnnotationsInfo = 'annotations.info',
  AnnotationsSetDescription = 'annotations.setDescription',
  AnnotationsSetLabelsShown = 'annotations.setLabelsShown',
  AnnotationsSetTitle = 'annotations.setTitle',
  AnnotationsUpdate = 'annotations.update',
  AnnotationsSetEnabled = 'annotations.setEnabled',
  CameraInfo = 'camera.info',
  CameraOrbit = 'camera.orbit',
  CameraPan = 'camera.pan',
  CameraReset = 'camera.reset',
  CameraSet = 'camera.set',
  CameraZoom = 'camera.zoom',
  GetAnnotationInfo = 'annotations.info',
  HideAnnotations = 'annotations.hide',
  HotspotsCreate = 'hotspots.create',
  HotspotsDestroy = 'hotspots.destroy',
  HotspotsHide = 'hotspots.hide',
  HotspotsInfo = 'hotspots.info',
  HotspotsShow = 'hotspots.show',
  HotspotsTypes = 'hotspots.types',
  HotspotsUpdate = 'hotspots.update',
  HumanInfo = 'human.info',
  InputDisable = 'input.disable',
  InputEnable = 'input.enable',
  // Labels API
  LabelsCreate = 'labels.create',
  LabelsDestroy = 'labels.destroy',
  LabelsInfo = 'labels.info',
  LabelsHide = 'labels.hide',
  LabelsSetEnabled = 'labels.setEnabled',
  LabelsShow = 'labels.show',
  LabelsUpdate = 'labels.update',
  LabelsCanvasUpdate = 'labels.canvasUpdate',
  // labels internal use
  LabelsSetScale = 'labels.setScale',
  // Quiz API
  QuizInfo = 'quiz.info',
  QuizEnter = 'quiz.enter',
  QuizExit = 'quiz.exit',
  QuizQuestion = 'quiz.currentQuestion',
  QuizSubmit = 'quiz.submit',
  QuizNextQuestion = 'quiz.next',
  QuizPreviousQuestion = 'quiz.previous',
  QuizSelectQuestion = 'quiz.select',
  QuizSet = 'quiz.set',
  QuizReset = 'quiz.reset',
  // scene
  SceneMetaData = 'scene.metadata',
  SceneSetHighlightColor = 'scene.setHighlightColor',
  SceneColorObject = 'scene.colorObject',
  SceneDisableHighlight = 'scene.disableHighlight',
  SceneEnableHighlight = 'scene.enableHighlight',
  SceneGetColor = 'scene.getColor',
  SceneInfo = 'scene.info',
  SceneLoad = 'scene.load',
  ScenePick = 'scene.pick',
  SceneReset = 'scene.reset',
  SceneSelectObjects = 'scene.selectObjects',
  SceneShowObjects = 'scene.showObjects',
  SceneTransformObject = 'scene.transformObject',
  SceneUncolorObject = 'scene.uncolorObject',
  SceneSnapshot = 'scene.snapshot',
  SceneCapture = 'scene.capture',
  SceneRestore = 'scene.restore',
  SceneEnableXrayMode = 'scene.enableXray',
  SceneDisableXrayMode = 'scene.disableXray',
  SceneSetLayersSliderPosition = 'scene.setLayersSliderPosition',
  SceneGetLayers = 'scene.getLayers',
  SceneSetBaseDirectory = 'scene.setBaseDirectory',
  ShowAnnotations = 'annotations.show',
  SetAnnotationsShown = 'annotations.setShown',
  TimelineInfo = 'timeline.info',
  TimelineQuery = 'timeline.query',
  TimelineNext = 'timeline.nextChapter',
  TimelinePause = 'timeline.pause',
  TimelinePlay = 'timeline.play',
  TimelinePrev = 'timeline.previousChapter',
  TimelineSet = 'timeline.set',
  UIGetBackground = 'ui.getBackground',
  UIGetDisplay = 'ui.getDisplay',
  UIGetWorldPosition = 'ui.getWorldPosition',
  UISetBackground = 'ui.setBackground',
  UISetDisplay = 'ui.setDisplay',
  UIResetDisplay = 'ui.resetDisplay',
  UISnapshot = 'ui.snapshot',
  focusObject = 'focus.focusObject',
  dissectSetEnabled = 'dissect.setEnabled',
  pickSingleSetEnabled = 'pick.single.setEnabled',
  pickMultiSetEnabled = 'pick.multi.setEnabled',
  getCanvasPos = 'scene.getCanvasPos',
  sceneSetClickMode = 'scene.setClickMode',
  sceneGetClickMode = 'scene.getClickMode',
  IsolateObject = 'scene.isolateObject',
  setCameraMode = 'camera.setCameraMode',
  // #TODO[AC]: implement private API calls
  // SetInitialEnabled = 'widget.enableInitial',
  // SetInitialDisabled = 'widget.disableInitial',
  // SetScrollEnabled = 'widget.enableScroll',
  // SetScrollDisabled = 'widget.disableScroll',
  UISetOndemand = 'ui.setOndemand',
  UISetLoadingExperience = 'ui.setLoadingExperience',
  UISetScrollCaptureMode = 'ui.setScrollCaptureMode',
  UISetTutorial = 'ui.setTutorial',
}
